<template>
  <BCard>

    <!-- Media -->
    <BMedia class="mb-2">
      <template #aside>
        <BAvatar ref="previewEl" :src="group.avatar" :text="avatarText(group.fullName)" size="90px" rounded />
      </template>

      <h4 class="mb-1"> {{ group.name }} </h4>
    </BMedia>

    <!-- Group Info: Input Fields -->
    <ValidationObserver ref="form" #default="{invalid}">
      <BForm @submit.prevent="onSubmit">

        <BRow>
          <BCol cols="12" md="4" >
            <h3>Datos generales</h3>
          </BCol>
        </BRow>
        
        <BRow> 
          <TextInputValidated vsName="Name" :vsModel.sync="group.name" vsMd="4" vsRequired vsRules="required"/>
          <vSelectValidated vsName="Status" :vsModel.sync="group.status" :vsOptions="statusOptions" vsLabel="label" vsMd="4" vsRequired vsRules="required" :vsReduce="status => status.value" />
        </BRow>

        <BRow class="mt-2" >
          <BCol cols="12" md="4" >
            <h3>{{$t('Contact data')}}</h3>
          </BCol>
        </BRow>

        <BRow>
          <TextInputValidated vsName="Email" :vsModel.sync="group.email" vsMd="4" vsRequired vsRules="required|email"/>
          <TextInputValidated vsName="Phone" :vsModel.sync="group.phone" vsMd="4" />
          <TextInputValidated vsName="Phone 2" :vsModel.sync="group.phone2" vsMd="4"/>
        </BRow>

        <BRow class="mt-2">
          <BCol cols="12" md="4" >
            <h3>Datos fiscales</h3>
          </BCol>
        </BRow>

        <BRow>
          <TextInputValidated vsName="Business name" :vsModel.sync="group.company_name" vsMd="4"/>
          <TextInputValidated vsName="Address" :vsModel.sync="group.address" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''" vsMd="4"/>
          <TextInputValidated vsName="Town" :vsModel.sync="group.city" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''" vsMd="4"/>
          <NumberInputValidated vsName="Postal code" :vsModel.sync="group.postal_code" :vsRequired = "group.company_name ? false : true" :vsRules="group.company_name ? 'required' : ''" vsMd="4"/>
          <vSelectValidated vsName="Province" :vsModel.sync="group.province_id" :vsOptions="provinces" :vsReduce="pr=> pr.id" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>
          <vSelectValidated vsName="Country" :vsModel.sync="group.country_id" :vsOptions="countries" :vsReduce="country=> country.id" vsLabel="name" vsMd="4" vsRequired vsRules="required"/>
          <vSelectValidated v-if="pitsOptions" vsName="IRPF" :vsModel.sync="group.pit_id" :vsOptions="pitsOptions" vsLabel="name" vsMd="4"  :vsReduce="pit => pit.id" :vsClearable="true"/>
          <NumberInputValidated vsName="Días vencimiento factura" :vsModel.sync="group.payment_days" vsRequired vsMd="4" />
        </BRow>

        <!-- Cajas -->
        <BRow class="mt-2">
          <BCol cols="12" md="4">
            <h3>Configuración de cajas</h3>
          </BCol>
        </BRow>

        <BRow>
          <NumberInputValidated vsName="Saldo inicial" :vsModel.sync="group.initial_balance" vsMd="6" />
        </BRow>

        <!-- Action Buttons -->
        <BRow class="mt-3">
          <BCol cols="12" md="4" >
            <BButton variant="primary" class="mb-1 mb-sm-0 mr-0 mr-sm-1" :block="$store.getters['app/currentBreakPoint'] === 'xs'" @click="onSubmit"> {{ $t("Save Changes") }} </BButton>
            <BButton variant="outline-secondary" type="reset" @click="showAddGroup=false; showListGroup=true" :block="$store.getters['app/currentBreakPoint'] === 'xs'"> {{$t('Cancel')}} </BButton>
          </BCol>
        </BRow>
      </BForm>
    </ValidationObserver>

  </BCard>
</template>

<script>
import { BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup, BFormInvalidFeedback } from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { required, email } from 'vee-validate/dist/rules'
import { inject, ref } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import NumberInputValidated from '@/components/forms/NumberInputValidated.vue'
import TextInputValidated from '@/components/forms/TextInputValidated.vue'
import formValidation from '@core/comp-functions/forms/form-validation'
import vSelectValidated from '@/components/forms/vSelectValidated.vue'
import popups from '@/hooks/popups'
import vSelect from 'vue-select'
import i18n from '@/libs/i18n'
import router from '@/router'
import axios from '@axios'
import { addGroup  } from '@/composables/groupService'

export default {
  components: { NumberInputValidated, TextInputValidated, vSelectValidated, BButton, BMedia, BAvatar, BRow, BCol, BFormGroup, BFormInput, BForm, BTable, BCard, BCardHeader, BCardTitle, BFormCheckbox, BFormCheckboxGroup, ValidationProvider, ValidationObserver, BFormInvalidFeedback, vSelect },
  setup() {
    const { getValidationState } = formValidation()
    const { errorToast, successToast } = popups()
    const countries = inject('countries')
    const provinces = inject('provinces')
    const group = inject('group')
    const previewEl = ref(null)
    const pitsOptions = ref(null)
    
    const showAddGroup = inject('showAddGroup')
    const showListGroup = inject('showListGroup')

    extend('required', required)
    extend('email', email)


    const onSubmit = async function(){

        this.$refs.form.validate().then(async success => {
          if(success){
            let response = await addGroup(group.value)
            if(response.data.success){
              successToast('Sucursal añadida correctamente')
              showAddGroup.value = false
              showListGroup.value = true
            } else {
              errorToast("Error añadiendo sucursal")
            }
          }
        })
      }
    
    const fetchPits = () => {
      axios.get('pits').then((response) => { pitsOptions.value=response.data })
    }

    fetchPits()

    const statusOptions = [
      { label: i18n.t('Active'), value: true },
      { label: i18n.t('Inactive'), value: false },
    ]


    return {
      getValidationState,
      statusOptions,
      avatarText,
      previewEl,
      countries,
      provinces,
      onSubmit,
      group,
      pitsOptions,
      showAddGroup,
      showListGroup
    }
  },

}
</script>

<style lang="scss">
@import '~@core/scss/vue/libs/vue-select.scss';
</style>


